module.exports = ".example-table {\n  position: relative;\n}\n.example-table .panel {\n  overflow: auto;\n  margin-top: 20px;\n}\n.example-table table {\n  width: 100%;\n}\n.example-table th,\n.example-table td {\n  padding: 0 10px;\n  border: 1px solid lightgrey;\n  text-align: center;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ops-support/merchant-bulk-create/merchant-bulk-create.component.less
// module id = 1208
// module chunks = 0